import apiService from './api';

const carePartnerService = {
  getTypes() {
    return apiService.get('/care-partners/types');
  },

  list(params = {}) {
    return apiService.get('/care-partners', { params });
  },

  getById(id) {
    return apiService.get(`/care-partners/${id}`);
  },

  create(payload) {
    return apiService.post('/care-partners', payload);
  },

  update(id, payload) {
    return apiService.put(`/care-partners/${id}`, payload);
  },

  remove(id) {
    return apiService.delete(`/care-partners/${id}`);
  }
};

export default carePartnerService;
